import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Auth Pages
import LoginPage from './pages/LoginPage';

// Main Pages
import HomePage from './pages/HomePage';
import CourseSchedulePage from './pages/CourseSchedulePage';
import StudentRecordPage from './pages/StudentRecordPage';

// Student Services Pages
import MyChecklistPage from './pages/MyChecklistPage';
import MyFinancialAidPage from './pages/MyFinancialAidPage';
import MyHousingPage from './pages/MyHousingPage';
import MyRegistrationPage from './pages/MyRegistrationPage';
import MyBillPage from './pages/MyBillPage';
import ElectronicRefundPage from './pages/ElectronicRefundPage';
import MyDegreePathPage from './pages/MyDegreePathPage';
import MyPersonalInfoPage from './pages/MyPersonalInfoPage';
import MyGraduateAdmissionsPage from './pages/MyGraduateAdmissionsPage';
import TextOptInPage from './pages/TextOptInPage';
import My1098TPage from './pages/My1098TPage';
import HealthPortalPage from './pages/HealthPortalPage';

// Quick Tools Pages
import BoxPage from './pages/BoxPage';
import CatCardPage from './pages/CatCardPage';
import CatCoursesPage from './pages/CatCoursesPage';
import EmailPage from './pages/EmailPage';
import VPNPage from './pages/VPNPage';
import ZoomPage from './pages/ZoomPage';
import CampusReadyPage from './pages/CampusReadyPage';
import CalmPage from './pages/CalmPage';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected Routes - Main Pages */}
          <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
          <Route path="/course-schedule" element={<ProtectedRoute><CourseSchedulePage /></ProtectedRoute>} />
          <Route path="/student-record" element={<ProtectedRoute><StudentRecordPage /></ProtectedRoute>} />

          {/* Protected Routes - Student Services */}
          <Route path="/checklist" element={<ProtectedRoute><MyChecklistPage /></ProtectedRoute>} />
          <Route path="/financial-aid" element={<ProtectedRoute><MyFinancialAidPage /></ProtectedRoute>} />
          <Route path="/housing" element={<ProtectedRoute><MyHousingPage /></ProtectedRoute>} />
          <Route path="/registration" element={<ProtectedRoute><MyRegistrationPage /></ProtectedRoute>} />
          <Route path="/bill" element={<ProtectedRoute><MyBillPage /></ProtectedRoute>} />
          <Route path="/refund" element={<ProtectedRoute><ElectronicRefundPage /></ProtectedRoute>} />
          <Route path="/degree-path" element={<ProtectedRoute><MyDegreePathPage /></ProtectedRoute>} />
          <Route path="/personal-info" element={<ProtectedRoute><MyPersonalInfoPage /></ProtectedRoute>} />
          <Route path="/grad-admissions" element={<ProtectedRoute><MyGraduateAdmissionsPage /></ProtectedRoute>} />
          <Route path="/text-opt-in" element={<ProtectedRoute><TextOptInPage /></ProtectedRoute>} />
          <Route path="/1098t" element={<ProtectedRoute><My1098TPage /></ProtectedRoute>} />
          <Route path="/health" element={<ProtectedRoute><HealthPortalPage /></ProtectedRoute>} />

          {/* Protected Routes - Quick Tools */}
          <Route path="/box" element={<ProtectedRoute><BoxPage /></ProtectedRoute>} />
          <Route path="/catcard" element={<ProtectedRoute><CatCardPage /></ProtectedRoute>} />
          <Route path="/cat-courses" element={<ProtectedRoute><CatCoursesPage /></ProtectedRoute>} />
          <Route path="/email" element={<ProtectedRoute><EmailPage /></ProtectedRoute>} />
          <Route path="/vpn" element={<ProtectedRoute><VPNPage /></ProtectedRoute>} />
          <Route path="/zoom" element={<ProtectedRoute><ZoomPage /></ProtectedRoute>} />
          <Route path="/campus-ready" element={<ProtectedRoute><CampusReadyPage /></ProtectedRoute>} />
          <Route path="/calm" element={<ProtectedRoute><CalmPage /></ProtectedRoute>} />

          {/* Default Route */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Catch all - redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
